(function () {
  'use strict';

  /**
   * roundTo99: öre in, öre out.
   * If you change this function, update warranty-cart-transform/extensions/warranty-price/src/run.js too.
   */
  function roundTo99(ore) {
    var kr = ore / 100;
    var lower = Math.floor((kr + 1) / 100) * 100 - 1;
    var candidate = lower < 0 ? 99 : lower;
    return (kr - candidate <= 21 ? candidate : candidate + 100) * 100;
  }

  function formatSEK(ore) {
    return new Intl.NumberFormat('sv-SE', {
      style: 'currency',
      currency: 'SEK',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(ore / 100);
  }

  /**
   * Resolve the warranty tier for a computed price in öre.
   * Exact match first, then nearest price >= warrantyOre, then largest available.
   * Returns {vid, ore} — ore is the ACTUAL tier price. The UI must display that,
   * so the shown price is always exactly what the added variant charges.
   */
  function resolveWarranty(warrantyOre) {
    var map = window.warrantyVariantsByOre || {};
    if (map[String(warrantyOre)]) return { vid: map[String(warrantyOre)], ore: warrantyOre };

    var sorted = Object.keys(map).map(Number).filter(function (p) { return p > 0; }).sort(function (a, b) { return a - b; });
    if (sorted.length === 0) return null;

    for (var i = 0; i < sorted.length; i++) {
      if (sorted[i] >= warrantyOre) return { vid: map[String(sorted[i])], ore: sorted[i] };
    }
    // All tiers are cheaper than warrantyOre — use the highest available
    return { vid: map[String(sorted[sorted.length - 1])], ore: sorted[sorted.length - 1] };
  }

  function addWarrantyToCart(variantId, baseOre, productTitle, productSku) {
    var artikelLabel = productTitle;
    if (productSku) artikelLabel += ' (' + productSku + ')';

    // Don't add a second warranty for the same article (e.g. product re-added,
    // or already covered via the cart-page upsell).
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var exists = cart.items.some(function (i) {
          return i.properties && i.properties._is_warranty === 'true' && i.properties.Artikel === artikelLabel;
        });
        if (exists) return { skipped: true };
        return doAdd(variantId, baseOre, artikelLabel);
      });
  }

  function doAdd(variantId, baseOre, artikelLabel) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: {
              'Artikel': artikelLabel,
              '_is_warranty': 'true',
              '_warranty_base_ore': String(baseOre),
            },
          },
        ],
      }),
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart add failed: ' + res.status);
      return res.json();
    });
  }

  function showStatus(message) {
    var el = document.getElementById('warranty-addon-status');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    setTimeout(function () { el.hidden = true; }, 5000);
  }

  function init() {
    var checkbox = document.getElementById('warranty-addon-checkbox');
    if (!checkbox) return;

    var baseOre = parseInt(checkbox.dataset.baseOre, 10);
    var productTitle = checkbox.dataset.productTitle || '';
    var productSku = checkbox.dataset.productSku || '';
    // Resolve the tier up-front and display ITS price — shown == charged.
    var tier = resolveWarranty(roundTo99(Math.round(baseOre * 0.15)));

    var priceEl = document.getElementById('warranty-addon-price');
    if (priceEl && tier) {
      // Show the tier's price in the current market currency (Shopify-formatted,
      // e.g. "€99,00 EUR"). Falls back to SEK formatting only if the map is missing.
      var money = (window.warrantyMoneyByVid || {})[tier.vid];
      priceEl.textContent = money || formatSEK(tier.ore);
    }

    var warrantyPending = false;

    var productFormEl = document.querySelector('product-form');
    if (!productFormEl) return;

    var form = productFormEl.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        warrantyPending = checkbox.checked;
      });
    }

    if (typeof window.subscribe === 'function') {
      window.subscribe('cart-update', function (data) {
        if (data.source !== 'product-form') return;
        if (!warrantyPending) return;
        warrantyPending = false;

        if (!tier) {
          console.error('[warranty-addon] Warranty product has no variants. Add price tiers to Förlängd garanti in Shopify admin.');
          return;
        }

        addWarrantyToCart(tier.vid, baseOre, productTitle, productSku)
          .then(function () {
            showStatus('✓ Garanti tillagd i varukorgen');
            if (typeof window.publish === 'function') {
              window.publish('cart-update', { source: 'warranty-addon' });
            }
          })
          .catch(function (err) {
            console.error('[warranty-addon] Failed to add warranty to cart:', err);
          });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
